(function Module() {
	'use strict';

	module.exports = {
		usa: {
			date: 'MM-DD-YYYY',
			dateMedium: 'MMM DD, YYYY',
			dateLong: 'MMMM DD, YYYY'
		},
		aus: {
			date: 'DD-MM-YYYY',
			dateMedium: 'DD MMM YYYY',
			dateLong: 'DD MMMM YYYY'
		},
		international: {
			date: 'YYYY-MM-DD',
			dateMedium: 'DD MMM YYYY',
			dateLong: 'DD MMMM YYYY'
		}
	};
})();
